import { Box, Button, Flex, Icon, Text } from "@chakra-ui/react";
import { ArrowBackIcon } from "@chakra-ui/icons";
import {
  EhrName,
  EhrProvider,
  PatientOverview,
  PatientOverviewV2,
  SharedStateProvider,
} from "@metriport/shared-internal";
import { useNavigate, useParams } from "react-router-dom";
import { ossBaseUrlEmbedPage } from "../../../api/api";
import { useAppContext } from "../../contexts/app/index";

export default function TcmPatientPage() {
  const { state } = useAppContext();
  const { patientId } = useParams<{ patientId: string }>();
  const navigate = useNavigate();

  if (!state.isLoaded || !patientId) {
    return null;
  }

  const ehrDetails = {
    ehrPatientId: patientId,
    name: EhrName.Embed,
  };

  function handleBackToTcm() {
    navigate("/embed/app/transitions-of-care");
  }

  return (
    <Box>
      <Flex
        align="center"
        px={4}
        height="14"
        bg="white"
        borderBottomWidth="1px"
        borderBottomColor="gray.200"
      >
        <Button
          leftIcon={<Icon as={ArrowBackIcon} color="gray.600" _groupHover={{ color: "white" }} />}
          size="sm"
          variant="ghost"
          color="gray.900"
          role="group"
          _hover={{
            bg: "#748df0",
            color: "white",
          }}
          onClick={handleBackToTcm}
        >
          Back to Transitions of Care
        </Button>
      </Flex>
      {patientId ? (
        <SharedStateProvider
          authToken={state.authToken}
          baseUrl={ossBaseUrlEmbedPage}
          ehrDetails={ehrDetails}
          featureFlags={state.featureFlags}
        >
          {state.featureFlags?.shouldShowLegacyDashV1 ? (
            <PatientOverview patientId={patientId} />
          ) : (
            <EhrProvider patientId={patientId} ehrDetails={ehrDetails}>
              <PatientOverviewV2 patientId={patientId} />
            </EhrProvider>
          )}
        </SharedStateProvider>
      ) : (
        <Text>No Patient</Text>
      )}
    </Box>
  );
}
